import React, { useEffect, useRef, useState } from "react";
import { Table } from "../../components/Table/Table";
import {
    delete_icon,
    dummmyimage,
    dummyimage,
    edit_icon,
    eye_icon,
    password_icon,
    toggle_off,
    toggle_on,
    view_icon,
} from "../../assets/imgs";
import { data, useNavigate } from "react-router-dom";
import { admin_list } from "../redux/api/dummyJson";
import CancelIcon from "@mui/icons-material/Cancel";
import apiRequest from "../redux/api/apiRequest";
import {
    useCompanyAddMutation,
    useCompanyDeleteMutation,
    useCompanyEditMutation,
    useCompanyListMutation,
    useLazyCompanyListViewQuery,
    useLazyCompanyRolesListQuery,
    useLazyCompanyStatusQuery,
    useLazyLocationListQuery,
} from "../redux/api/api";
import { EMAIL, PASS } from "../redux/api/Constants";
import { toast } from "react-toastify";

const Company = () => {
    const navigate = useNavigate();
    const [popup, setPopup] = useState("");
    const [id, setID] = useState("");
    const [editMode, setEditMode] = useState(false);
    const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
    const [deletePopup, setDeletePopup] = useState("");
    const [list, setList] = useState([]);
    const [page, setPage] = useState(1);
    const [pagination, setPagination] = useState("");
    const [visible, setVisible] = useState(false);
    const [rolesList, setRoleslist] = useState();
    const [locList, setLoclist] = useState([]);
    const [selectedImage, setSelectedImage] = useState();
    const [image, setImage] = useState("");
    const [count, setCount] = useState();
    const [images, setImages] = useState([]);
    const inputRef = useRef(null);
    const [banner, setBanner] = useState("");

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        setSelectedImage(event.target.files[0]);
    };
    const handleImageClick = () => {
        inputRef.current.click();
    };
    const [admindetails, setAdminDetails] = useState({
        id: "",
        company_name: "",
        name: "",
        email: "",
        role_id: "",
        phone: "",
        password: "",
        password_confirmation: "",
        location: "",
        logo: "",
    });
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(false);
    const [companyList] = useCompanyListMutation();
    const [addCompany] = useCompanyAddMutation();
    const [companyRolesList] = useLazyCompanyRolesListQuery();
    const [companyLocationList] = useLazyLocationListQuery();
    const [adminStatus] = useLazyCompanyStatusQuery();
    const [deleteAdmin] = useCompanyDeleteMutation();
    const [updateAdmin] = useCompanyEditMutation();
    const [companyView] = useLazyCompanyListViewQuery();

    const handleStatus = async (id) => {
        const res = await apiRequest(adminStatus, id);
        if (res?.status == "success") {
            toast.success(res?.message);
            getList();
        }
    };

    const handleDelete = async (id) => {

        const res = await apiRequest(deleteAdmin, id);
        if (res?.status == "success") {
            toast.success(res?.message);
            setDeletePopup("");
            getList();
        }
    };

    function isValidURL(string) {
        var res = string.match(
            /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        );
        return res !== null;
    }

    const companyListView = async (id, type) => {
        const res = await apiRequest(companyView, id);
        if (res?.status == "success") {
            let data = res?.data;
            setSelectedImage(data?.logo)
            Object.keys(admindetails).forEach((item) => {
                // console.log(item);
                setAdminDetails((prevState) => ({
                    ...prevState,
                    [item]:
                        item == "company_name"
                            ? data?.company_name
                            : item == "name"
                                ? data?.name
                                : item == "email"
                                    ? data?.email
                                    : item == "password"
                                        ? data?.password
                                        : item == "location"
                                            ? data?.location
                                            : item == "logo"
                                                ? data?.logo
                                                : item == "role_id"
                                                    ? data?.role_id
                                                    : item == "phone"
                                                        ? data?.phone
                                                        : item == "id"
                                                            ? data?.id
                                                            : "",
                }));
            });
            setEditMode(true);
            setPopup(type);
        }
        // console.log(res);
    };

    const getList = async (search) => {
        const formdata = new FormData();
        formdata.append("rows", 10);
        formdata.append("search", search ? search : "");
        formdata.append("order", "asc");
        formdata.append("page", page);
        const res = await apiRequest(companyList, formdata);
        if (res?.status == "success") {
            setList(res?.lists);
            setCount(res?.pagination_meta)
            setPagination(res?.pagination_meta);
        }
    };

    const getRolesList = async () => {

        const res = await apiRequest(companyRolesList);
        console.log(res, 'roles')
        if (res?.status == "success") {
            setRoleslist(res?.role);
            setAdminDetails((prevState) => ({
                ...prevState,
                'role_id': res?.role?.id ? res?.role?.id : '',
            }));
        }
    };
    const getLocationList = async () => {
        const res = await apiRequest(companyLocationList);
        if (res?.status == "success") {
            setLoclist(res?.data);
        }
    };

    useEffect(() => {
        if (givenpermissions?.includes("CAN-List-COMPANIES")) {
            getList();
        }
        getRolesList();
        getLocationList();
    }, []);


    console.log(admindetails.role_id, 'admindetails.role_id')

    const AdminAdd = async (id) => {
        if (
            !admindetails?.name ||
            !admindetails?.company_name ||
            !admindetails?.location ||
            !selectedImage ||
            admindetails?.phone?.length < 8 ||
            !admindetails?.email ||
            !admindetails?.email.match(EMAIL)
        ) {
            setError(true);
            return;
        }
        // if (!editMode) {
        //     if (
        //         admindetails?.password.length < 10 ||
        //         admindetails?.password_confirmation?.length < 10 ||
        //         !admindetails?.password.match(PASS) ||
        //         admindetails?.password != admindetails?.password_confirmation
        //     ) {
        //         setError(true);
        //         return;
        //     }
        // }
        setError(false);
        const formdata = new FormData();
        formdata.append("name", admindetails?.name);
        formdata.append("company_name", admindetails?.company_name);
        formdata.append("email", admindetails?.email);
        formdata.append("roles", rolesList?.id);
        formdata.append("phone", admindetails?.phone);
        if (admindetails?.password) {
            formdata.append("password", admindetails?.password);
        }
        if (admindetails?.password_confirmation) {
            formdata.append(
                "password_confirmation",
                admindetails?.password_confirmation
            );
        }
        formdata.append(
            "location",
            admindetails?.location
        );
        formdata.append(
            "logo",
            selectedImage
        );

        console.log('payload', formdata)
        setLoader(true);
        let res = {}
        if (editMode) {
            res = await apiRequest(updateAdmin, formdata, id)
        } else {
            res = await apiRequest(addCompany, formdata)
        }
        setLoader(false);
        setPopup("");
        setAdminDetails({});
        setEditMode(false);
        if (res?.status == "success") {
            toast.success(res?.message);
        } else if (res?.status == "error") {
            toast.error(res?.message);
        }
        getList();
    };
    // useEffect(() => {
    //     getList();
    // }, [page]);
    // console.log(page);

    const handleUpdate = (e) => {
        const { name, value } = e.target;
        setAdminDetails((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{row.index + 1}</p>;
                },
            },
            {
                Header: "Company Name",
                accessor: "company_name",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Primary Name",
                accessor: "name",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: " Email",
                accessor: "email",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Number",
                accessor: "phone",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Role",
                accessor: "role",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Location",
                accessor: "location",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Total Devices",
                accessor: "device_count",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Daily Log",
                accessor: "Log",
                Cell: ({ value, row }) => {
                    return <div>
                        <button
                            onClick={() => {
                                navigate("/daily-log")
                            }}
                            className="cust-btn "
                        >
                            <img src={view_icon} alt="" className="mx-2 edit-btn " />
                        </button>
                    </div>
                },
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: ({ value, row }) => {
                    return (
                        <div>
                            <button
                                onClick={() => {
                                    if (givenpermissions?.includes("CAN-Status-COMPANIES")) {
                                        handleStatus(row.original.id);
                                    }
                                }}
                                className={`border-0 ms-2 cust-btn `}
                            >
                                {value == 1 ? (
                                    <img className="toggle-btn" src={toggle_on} />
                                ) : (
                                    <img className="toggle-btn" src={toggle_off} />
                                )}
                            </button>
                        </div>
                    );
                },
            },


            {
                Header: "Action",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex ac-jc">
                                {givenpermissions?.includes("CAN-View-COMPANIES") && (
                                    <button
                                        onClick={() => {
                                            // companyListView(row.original.id, "view");
                                            navigate("/user-list", { state: { id: row?.original?.id } })
                                        }}
                                        className="cust-btn "
                                    >
                                        <img src={view_icon} alt="" className="mx-2 edit-btn " />
                                    </button>
                                )}
                                {givenpermissions?.includes("CAN-Edit-COMPANIES") && (
                                    <button
                                        onClick={() => {
                                            setID(row?.original?.id)
                                            setPopup(row.original.id); setEditMode(true);
                                            companyListView(row.original.id, "edit");
                                        }}
                                        className="cust-btn "
                                    >
                                        <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                                    </button>
                                )}
                                {/* {givenpermissions?.includes("CAN-Delete-COMPANIES") && (
                                    <button
                                        onClick={() => setDeletePopup(row.original.id)}
                                        className="cust-btn "
                                    >
                                        <img src={delete_icon} alt="" className="mx-2 edit-btn " />
                                    </button>
                                )} */}
                            </div>
                        </React.Fragment>
                    );
                },
            },
        ],
        []
    );

    return (
        <div className="dashRightView home_section">
            <div className="d-flex ac-jb">
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                    Company List
                </h2>
                {givenpermissions?.includes("CAN-Add-COMPANIES") && (
                    <button
                        onClick={() => { setPopup(true); setError(false) }}
                        className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn "
                    >
                        {" "}
                        + Add Company
                    </button>)}
            </div>

            <div className="d-flex ac-js mt-2 ">
                <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary mb-0 ">
                    Total Count :
                </h4>
                <h4 className="f2 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mb-0 ms-2">
                    {count?.total}
                </h4>
                <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary me-3 mb-0 ms-3">
                    Search
                </h4>
                <input
                    type="text"
                    className="input-pop ps-2"
                    placeholder=" Search"
                    onChange={(e) => {
                        getList(e.target.value);
                    }}
                />
            </div>
            {popup && (
                <div className="popup-design">
                    <div className="popup">
                        <div className="d-flex ac-jb">
                            <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                                {editMode ? "Edit Company" : "Add Company"}
                            </h2>
                            <button
                                onClick={() => {
                                    if (editMode) {
                                        setEditMode(false);
                                    }
                                    setPopup("");
                                    setSelectedImage("");
                                    setAdminDetails({});
                                }}
                                className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
                            >
                                <CancelIcon />
                            </button>
                        </div>
                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            Company Name
                        </h4>
                        <input
                            type="text"
                            className="input-pop ps-2 w-100"
                            placeholder="Company Name"
                            name="company_name"
                            onChange={(e) => {
                                handleUpdate(e);
                            }}
                            value={admindetails?.company_name}
                            disabled={popup == "view" ? true : false}
                        />
                        {error && !admindetails?.company_name && (
                            <p className="err">Enter Your Name</p>
                        )}
                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            Primary Person Name
                        </h4>
                        <input
                            type="text"
                            className="input-pop ps-2 w-100"
                            placeholder="Primary Person Name"
                            name="name"
                            onChange={(e) => {
                                handleUpdate(e);
                            }}
                            value={admindetails?.name}
                            disabled={popup == "view" ? true : false}
                        />
                        {error && !admindetails?.name && (
                            <p className="err">Enter Primary Person Name</p>
                        )}
                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            Primary Email ID
                        </h4>
                        <input
                            type="email"
                            className="input-pop ps-2 w-100"
                            placeholder=" Email Address"
                            name="email"
                            onChange={(e) => {
                                handleUpdate(e);
                            }}
                            value={admindetails?.email}
                            disabled={popup == "view" || popup == "edit" ? true : false}
                        />
                        {error &&
                            (!admindetails?.email || !admindetails?.email.match(EMAIL)) && (
                                <p className="err">Enter Valid Email</p>
                            )}
                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            Primary Mobile Number
                        </h4>
                        <input
                            type="number"
                            className="input-pop ps-2 w-100"
                            placeholder="Primary Mobile Number"
                            name="phone"
                            onChange={(e) => {
                                if (e.target.value?.length <= 8) {
                                    handleUpdate(e);
                                }
                            }}
                            value={admindetails?.phone}
                            disabled={popup == "view" ? true : false}
                        />
                        {error && admindetails?.phone?.length < 8 && (
                            <p className="err">Enter Valid Phone Number</p>
                        )}

                        {popup != "view" && (
                            <div>
                                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                                    Password
                                </h4>
                                <div className="input-pop mb-2 w-100 d-flex ac-jb">
                                    <input
                                        type={visible ? "text" : "password"}
                                        maxLength={20}
                                        className="cust-btn  w-90"
                                        placeholder="Password"
                                        name="password"
                                        autoComplete="off"
                                        onChange={(e) => {
                                            handleUpdate(e);
                                        }}
                                        value={admindetails?.password}
                                    />
                                    <img
                                        src={eye_icon}
                                        onClick={() => setVisible(!visible)}
                                        className="eye-icon pointer"
                                        alt=""
                                    />
                                </div>
                                {error &&
                                    !editMode &&
                                    (admindetails?.password?.length < 8 ||
                                        !admindetails?.password?.match(PASS)) && (
                                        <p className="err">
                                            {!admindetails?.password
                                                ? "Enter Your password"
                                                : !admindetails?.password?.match(PASS)
                                                    ? "Must include one special char & capital leteer"
                                                    : "Enter Minimum 8 Charactors"}
                                        </p>
                                    )}
                                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                                    Confirm Password
                                </h4>
                                <div className="input-pop mb-2 w-100 d-flex ac-jb">
                                    <input
                                        type={visible ? "text" : "password"}
                                        maxLength={20}
                                        className="cust-btn w-90"
                                        placeholder=" Confirm Password"
                                        name="password_confirmation"
                                        autoComplete="off"
                                        onChange={(e) => {
                                            handleUpdate(e);
                                        }}
                                        value={admindetails?.password_confirmation}
                                    />
                                    <img
                                        src={eye_icon}
                                        onClick={() => setVisible(!visible)}
                                        className="eye-icon pointer"
                                        alt=""
                                    />
                                </div>
                                {error &&
                                    !editMode &&
                                    (admindetails?.password_confirmation?.length < 8 ||
                                        admindetails?.password !=
                                        admindetails?.password_confirmation) && (
                                        <p className="err">
                                            {!admindetails?.password_confirmation
                                                ? "Enter Confirm Password"
                                                : admindetails?.password_confirmation?.length < 8
                                                    ? "Enter Minimum 8 Charactors"
                                                    : "Password Mismatch"}
                                        </p>
                                    )}

                            </div>
                        )}

                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            Roles
                        </h4>

                        <input name="role_id" readOnly value={rolesList?.name} className="input-pop ps-2 w-100" />
                        {/* {error && !admindetails?.role_id && (
                            <p className="err">Select Your Role</p>
                        )} */}

                        <div>
                            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                                Location
                            </h4>
                            <select name="location" value={admindetails?.location} onChange={(e) => {
                                handleUpdate(e);
                            }} className="input-pop ps-2 w-100" >
                                <option>Select Location</option>
                                {locList.map((item) => {
                                    return (
                                        <option value={item?.id}>{item?.name}</option>
                                    )
                                })}

                            </select>
                            {error && !admindetails?.location && (
                                <p className="err">Enter Your Location </p>
                            )}
                            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                                Company Logo Upload
                            </h4>
                            <div className="input-pop mb-2 w-100 d-flex ac-jb">
                                <div onClick={handleImageClick} className="position-relative w-100">
                                    <div className="d-flex ac-jb w-100">
                                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  ">
                                            Choose Upload Image
                                        </h4>
                                        <div>
                                            {typeof selectedImage === "string" ? (
                                                <img
                                                    alt="not found"
                                                    style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        borderRadius: "10px",
                                                    }}
                                                    src={selectedImage ? selectedImage : dummyimage}
                                                />
                                            ) : selectedImage?.name ? (
                                                <img
                                                    alt="not found"
                                                    style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        borderRadius: "10px",
                                                    }}
                                                    src={URL.createObjectURL(selectedImage)}
                                                />
                                            ) : (
                                                <img
                                                    alt="not found"
                                                    style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        borderRadius: "10px",
                                                    }}
                                                    src={dummyimage}
                                                />
                                            )}
                                            <input
                                                style={{
                                                    position: "absolute",
                                                    width: "40px",
                                                    height: "40px",
                                                    left: "0px",
                                                    top: "0px",
                                                }}
                                                type="file"
                                                hidden
                                                name="logo"
                                                accept="image/*"
                                                ref={inputRef}
                                                onChange={handleImageChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {error && !selectedImage && (
                                <p className="err">Enter Logo </p>
                            )}

                        </div>

                        {popup != "view" && (
                            <div className="d-flex ac-jc">
                                <button
                                    onClick={() => {
                                        AdminAdd(id);
                                    }}
                                    className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
                                >
                                    {loader && (
                                        <div
                                            class="spinner-border spinner-border-sm "
                                            role="status"
                                            style={{ marginRight: "5px" }}
                                        ></div>
                                    )}
                                    Submit
                                </button>
                            </div>
                        )}
                    </div>
                    {/* </div> */}
                </div >
            )
            }
            {deletePopup && (
                <div className="img-popup-design">
                    <div className="img-popup">
                        <p className="f3 ms-2 mt-1 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
                            Are you sure, want to Delete?
                        </p>
                        <div className="d-flex ac-jb px-2 mt-5">
                            <button onClick={() => setDeletePopup("")} className="no-btn">
                                No
                            </button>
                            <button
                                onClick={() => {
                                    handleDelete(deletePopup);
                                    setDeletePopup(false)
                                }}
                                className="yes-btn f2"
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            )
            }
            <Table
                columns={columns}
                setPageno={setPage}
                pagecount={pagination}
                data={list}
                show={true}
            />
        </div >
    );
};
export default Company